<template>
  <b-modal ref="activateSiteDocumentModal" :no-close-on-backdrop="noCloseOnBackdrop" :no-close-on-esc="noCloseOnEsc" size="lg" hide-footer hide-header>
    <div class="modal-content-box">
      <b-form @submit.prevent="yesAction">
        <span class="close-dialog-icon" @click="hide"><i class="fa fa-times" data-dismiss="modal" aria-hidden="true"></i></span>
        <b-container fluid>
          <b-row>
            <b-col>
              <p class="title">Activate Site Document for Participants</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <p class="para">
                Activating makes this site document visible to all selected participants within their profile.
              </p>
              <p class="para">
                Which Participant(s) would you like to activate the document for?
              </p>
            </b-col>
          </b-row>
          <b-row class="text-center justify-content-center pt-20">
            <b-col col md="auto">
              <b-button @click="hide" aria-label="no" class="btn-modal button-cancel">Cancel</b-button>
            </b-col>
            <b-col col md="auto">
              <b-button aria-label="no" @click="selectGroupOfParticipants" variant="outline-primary" class="btn-modal">Select Site Participant(s)</b-button>
            </b-col>
            <b-col col md="auto">
              <b-button aria-label="no" type="submit" variant="primary" class="btn-modal">All Site Participants</b-button>
            </b-col>
          </b-row>
        </b-container>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "activate-site-document-modal",
  data() {
    return {
      noCloseOnBackdrop: true,
      noCloseOnEsc: true
    };
  },
  methods: {
    show() {
      this.$refs.activateSiteDocumentModal.show();
    },
    hide() {
      this.$refs.activateSiteDocumentModal.hide();
    },
    yesAction() {
      this.$emit("assignAllParticipants");
      this.hide();
    },
    selectGroupOfParticipants() {
      this.$emit("assignGroupOfParticipants");
    }
  }
};
</script>

<style scoped lang="scss">
.modal-content-box {
  padding: 30px 0;
  border-radius: 3px;
  text-align: center;

  .title {
    font-size: 18px;
    font-weight: bold;
    color: #666669;
  }
  .para {
    font-size: 14px;
    color: #666669;
    font-weight: normal;
  }
}

.close-dialog-icon {
  position: absolute;
  right: 15px;
  top: 10px;
  cursor: pointer;
  font-size: 18px;
}

.btn-modal {
  border-radius: 4px;
  font-size: 14px;
  font-weight: normal;
  text-transform: none;
  letter-spacing: normal;
}

.button-cancel {
  background-color: #e0e0e0;
  color: #4a4a4a;
  border: none;
  padding-left: 20px;
  padding-right: 20px;
}

.button-invalidate {
  color: #fff;
  background-color: #f16559;
}
</style>
